<template>
    <div class="my-5">
        <dashboard-section-title>{{ $t('Points in the last 7 days') }}</dashboard-section-title>
        <template v-if="points && points.length">
            <v-card rounded flat outlined>
                <template v-for="(cardData, index) in entries">
                    <points-collected-card
                        :key="`${cardData.date}-${cardData.activityId}`"
                        :card-data="cardData"
                        :click-handler="onCardSelect"
                    />
                    <v-divider
                        v-if="index + 1 < entries.length"
                        :key="`divider-${cardData.date}-${cardData.activityId}`"
                    />
                </template>
            </v-card>
            <points-collected-details
                v-model="isDialogVisible"
                :card-data="selected"
                :refresh-list-action="refreshListAction"
            />
        </template>

        <v-card rounded flat outlined v-else>
            <v-skeleton-loader type="article" />
        </v-card>
    </div>
</template>

<script>
import moment from 'moment';
import PointsCollectedCard from './PointsCollectedCard';

export default {
    components: {
        PointsCollectedCard,
    },
    props: {
        refreshListAction: Function,
        points: Array,
    },
    data() {
        return {
            isDialogVisible: false,
            selected: null,
        };
    },
    computed: {
        organizationId() {
            return this.selectedOrganizationID;
        },
        entries() {
            const points = this.points ? [...this.points] : [];
            if (points.length) {
                const activities = {};

                for (const record of points) {
                    if (record.participant) {
                        const activity = record.activity;
                        const activityId = activity.id;
                        const date = record.date;
                        if (!activities.hasOwnProperty(activityId)) {
                            activities[activityId] = {};
                        }
                        if (!activities[activityId].hasOwnProperty(date)) {
                            activities[activityId][date] = {};
                        }
                        if (!activities[activityId][date].hasOwnProperty('participants')) {
                            activities[activityId][date].participants = [];
                        }
                        activities[activityId][date].participants.push({
                            id: record.participant.id,
                            name: `${record.participant.firstname} ${record.participant.lastname}`,
                        });
                        activities[activityId][date].id = record.id;
                        activities[activityId][date].date = date;
                        activities[activityId][date].activityId = activityId;
                        activities[activityId][date].activityTitle = activity.name;
                        activities[activityId][date].points = record.points;
                        activities[activityId][date].isQrScanType = activity.pointsApplyStrategy === 'scan';
                        activities[activityId][date].pointsCollected = record;
                    }
                }

                const entries = [];
                for (const activity of Object.values(activities)) {
                    for (const dateData of Object.values(activity)) {
                        entries.push(dateData);
                    }
                }
                entries.sort((a, b) => {
                    let aDate = new Date(moment(a.date, 'DD.MM.YYYY').format('YYYY-MM-DD'));
                    let bDate = new Date(moment(b.date, 'DD.MM.YYYY').format('YYYY-MM-DD'));

                    return bDate.getTime() - aDate.getTime();
                });
                return entries;
            }
        },
    },
    methods: {
        onCardSelect(cardData) {
            this.selected = cardData;
            this.isDialogVisible = true;
        },
    },
};
</script>
